exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".fade-enter-active, .fade-leave-active {\n    -webkit-transition: opacity .15s linear;\n    transition: opacity .15s linear;\n}\n.fade-enter, .fade-leave-to {\n    opacity: 0;\n}\n", "", {"version":3,"sources":["/home/ubuntu/BookingSystemV2/node_modules/bootstrap-vue/es/components/alert/alert.css"],"names":[],"mappings":"AAAA;IACI,wCAAgC;IAAhC,gCAAgC;CACnC;AACD;IACI,WAAW;CACd","file":"alert.css","sourcesContent":[".fade-enter-active, .fade-leave-active {\n    transition: opacity .15s linear;\n}\n.fade-enter, .fade-leave-to {\n    opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/lib??ref--2-2!./node_modules/bootstrap-vue/es/components/alert/alert.css
// module id = ./node_modules/css-loader/index.js??ref--2-1!./node_modules/postcss-loader/lib/index.js??ref--2-2!./node_modules/bootstrap-vue/es/components/alert/alert.css
// module chunks = 20